import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import { Link } from "react-router-dom";
import Leftpanel from "../../layout/Leftpanel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getAllIndustrylist,
  getIndustry,
  getAllIndustryDatalist,
  deleteIndustry,
} from "../../../../service/Industry/IndustryService";
import { Button, Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import SpinnerComponent from "../../../components/SpinnerComponent";
import { useTranslation } from "react-i18next";

const Industry = () => {
  const { t } = useTranslation();
  const [industryList, setAllIndustryList] = useState([]);
  const [industryId, setAllIndustryId] = useState("");
  const [industryDataList, setAllIndustryDataList] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteIndustryId, setDeleteIndustryId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const PER_PAGE = 10;

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * PER_PAGE;
  const currentPageData = industryDataList.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(industryDataList?.length / PER_PAGE);

  const handleCloseDelete = () => setShowDelete(false);

  useEffect(() => {
    getIndustryDataDropDownList();
  }, []);

  async function getIndustryDataDropDownList() {
    setIsLoading(true);
    getAllIndustrylist().then(function (result) {
      // console.log(result.data, "datadatadatadatada");
      const response = result.data;
      // console.log(response, "rrrr");
      setAllIndustryList(response.data.industryList);
      setIsLoading(false);
    });
  }

  let industryDropdown = <option>Loading...</option>;
  if (industryList && industryList.length > 0) {
    industryDropdown = industryList
      .filter((industryRow) => {
        // console.log(industryRow.isDelete, "isDeleted"); // Debugging
        return !industryRow.isDelete;
      })
      .map((industryRow, index) => (
        <option value={industryRow.id} key={index}>
          {industryRow.name}
        </option>
      ));
  }
  // console.log(industryList, "industryList");

  const onIndustry = (e) => {
    setAllIndustryId(e.target.value);
  };

  useEffect(() => {
    getIndustryDataList();
  }, []);

  async function getIndustryDataList() {
    setIsLoading(true);
    getAllIndustryDatalist().then(function (result) {
      const response = result.data;
      setAllIndustryDataList(response.data.myIndustryList);
      setIsLoading(false);
    });
  }

  const onAdd = () => {
    let industryName = industryList.find(
      (c) => c.id === Number(industryId)
    )?.name;

    if (industryId === "") {
      toast.error("Please select Industry");
    } else {
      setIsLoading(true);
      getIndustry(industryId, industryName, (r) => {
        if (r.success === true) {
          setAllIndustryId("");
          toast.success(r.message);
          getIndustryDataList();
          setIsLoading(false);
        } else {
          setIsLoading(false);
          toast.error(r.message);
        }
      });
    }
  };
  const onDelete = (data) => {
    setDeleteIndustryId(data);
    // console.log(data, "datadatadatadatadatadata");
    setShowDelete(true);
  };

  const onYes = () => {
    setIsLoading(true);
    deleteIndustry(deleteIndustryId, (res) => {
      // console.log(res, "response");
      if (res.success === true) {
        toast.success(res.message);
        setShowDelete(false);
        getIndustryDataList();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast.error(res.message);
      }
    });
  };

  const onNo = () => {
    setShowDelete(false);
  };
  return (
    <div className="container-fluid">
      <div className="dbMain industryBg">
        <Leftpanel breadcm="Other" />
        <div className="dbRight">
          <Header
            link="/dashboard"
            title={t("industry_configuration")} // Use translation
            description=""
          />
          <div className="commonBase mb-4">
            <div className="dbtableTop indtop">
              <div className="dbSearch">
                <h6>{t("add_new_industry")}</h6> {/* Use translation */}
              </div>
              <div className="dbtableSrchbg">
                <select
                  className="form-control"
                  value={industryId}
                  onChange={onIndustry}
                >
                  <option selected hidden>
                    {t("select_industry")} {/* Use translation */}
                  </option>
                  {industryDropdown}
                </select>
                <button className="commonButton" onClick={onAdd}>
                  <i className="fa-solid fa-plus"></i> {t("add_new_industry")}{" "}
                  {/* Use translation */}
                </button>
              </div>
            </div>
            <div className="dbMaintable currencyTable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("industry_name")}</th> {/* Use translation */}
                    <th>{t("number")}</th> {/* Use translation */}
                    <th>&nbsp;</th>
                    <th>{t("action")}</th> {/* Use translation */}
                  </tr>
                </thead>
                <tbody>
                  {isLoading && <SpinnerComponent isLoading={isLoading} />}
                  {currentPageData
                    ?.sort((a, b) => a?.Industry?.number - b?.Industry?.number)
                    ?.map((d, index) => (
                      <tr key={index}>
                        <td data-label={t("industry_name")}>{d?.name}</td>
                        <td data-label={t("industry_number")}>
                          {d?.Industry?.number ? d?.Industry?.number : "----"}
                        </td>
                        <td data-label="">&nbsp;</td>
                        <td data-label={t("action")}>
                          <i
                            className="fa-solid fa-trash-can"
                            onClick={onDelete.bind(null, d?.id)}
                          ></i>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {!isLoading && (
              <ReactPaginate
                previousLabel={t("previous")}
                nextLabel={t("next")}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
                forcePage={currentPage}
              />
            )}
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        <Modal show={showDelete} onHide={handleCloseDelete}>
          <Modal.Header closeButton>
            <Modal.Title>{t("delete_confirmation")}</Modal.Title>{" "}
            {/* Use translation */}
          </Modal.Header>
          <Modal.Body>
            <Button variant="primary" className="commonButton" onClick={onYes}>
              {t("yes")} {/* Use translation */}
            </Button>
            &nbsp; &nbsp;
            <Button variant="primary" className="commonButton" onClick={onNo}>
              {t("no")} {/* Use translation */}
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Industry;
